export default "__VITE_ASSET__DhtkZy1p__"